import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button'
import useToken from '../../useToken';
import { useAuth } from '../../contexts/AuthContext'
import { useSelector, useDispatch } from 'react-redux';
import { fetchReport } from '../../features/harvest_report/harvestReportSlice';
import Table from './HarvestTable';
import Chart from './Chart';
import { Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {  MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import { endOfMonth, startOfMonth, subYears, subMonths } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import * as CsvExporter from '../../CsvExporter'
import { CSVLink } from "react-csv";

const theme = createTheme({
  palette: {
    primary: { main: "#657a71", contrastText: "#fff" },
  },
});
const useStyles = makeStyles ({
      root: {
              display: 'flex',
            },
      toolbar: {
              paddingRight: 24, // keep right padding when drawer closed
            },
      toolbarIcon: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 8px',
            },
      menuButton: {
              marginRight: 36,
            },
      menuButtonHidden: {
              display: 'none',
            },
      title: {
              flexGrow: 1,
            },
      content: {
              flexGrow: 1,
              height: '100vh',
              overflow: 'auto',
            },
      container: {
              paddingTop: 1,
              paddingBottom: 1,
            },
      paper: {
              display: 'flex',
              flexDirection: 'column',
            },
      fixedHeight: {
              height: 400,
            },
      formControl: {
        margin: 10,
        marginLeft: 30,
        minWidth: 300,
      },
      buttonMargin: {
        marginTop: 20,
      },
      selectEmpty: {
        marginTop: 10,
      },
      link: {
        textDecoration: 'none', 
        color: "#657a71",
        marginRight: 20,
        margin:10,
        border:1 ,  
      }
});

const HarvestReport = () => {
  const [crop, setCrop] = React.useState("Xiao Bai Cai")
  
  const {token, setToken} = useToken()
  const dispatch = useDispatch()
  const { logout } = useAuth()
  const report = useSelector((state: any) => state.harvest_report.reportData);
  const [selectedFromDate, setSelectedFromDate] = React.useState(
    startOfMonth(subMonths(subYears(new Date(),1),1))  );
  const [selectedToDate, setSelectedToDate] = React.useState(
    endOfMonth(new Date())
  );
  const [csvData, setCsvData] = React.useState({filename:"", data:""})

  useEffect(() => {
      dispatch(fetchReport({token, crop, selectedFromDate, selectedToDate}))
    }, [dispatch]);

  if (report.error === "unauthorized") {
      logout()
      window.location.reload();
  }

    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    
    const handleCrop = (event) => {
      setCrop(event.target.value)
      const { type, checked, name, value } = event.target;
      const crop = value
      dispatch(fetchReport({token, crop, selectedFromDate, selectedToDate}))
    }

    const handleSelectFrom = (newFromDate) => {
      if (newFromDate < selectedToDate) {
        setSelectedFromDate(newFromDate)
        const selectedFromDate = newFromDate
        dispatch(fetchReport({token, crop, selectedFromDate, selectedToDate}))
      } else {
        alert("From date is newer than To date.")
      }
    }

    const handleSelectTo = (newToDate) => {
      if (newToDate > selectedFromDate) { 
        setSelectedToDate(newToDate)
        const selectedToDate = newToDate
        dispatch(fetchReport({token, crop, selectedFromDate, selectedToDate}))
      }else {
        alert("To date is older than From date.")
      }
    }

    const exportCSV = CsvExporter.getHarvest({harvest: report.data.Data})

    if (report.status === "idle") { 
        return (
         <Container maxWidth="lg" className={classes.container}>
         <h1>Harvest</h1>

         <Grid container>
         <Grid item xs={5}>
         <FormControl className={classes.formControl}>
         <InputLabel id="crop-label">Select crop</InputLabel>
         <Select
          labelId="crop-label"
          id="crop"
          value={crop}
          onChange={handleCrop}
         >
          { 
              report.crops.map((crop, index) => {
                return <MenuItem key={index} value={crop}>{crop}</MenuItem>
              }
          )}
        </Select>
        </FormControl>
         </Grid>
  
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid>         
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          openTo="year"
          views={["year", "month"]}
          label="From"
          helperText="Start from year selection"
          value={selectedFromDate}
          onChange={handleSelectFrom}
        />  
        </ThemeProvider>
        </Grid>
        </MuiPickersUtilsProvider>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid>
        <ThemeProvider theme={theme}>
        <DatePicker
          variant="inline"
          openTo="year"
          views={["year", "month"]}
          label="To"
          helperText="Start from year selection"
          value={selectedToDate}
          onChange={handleSelectTo}
        />
        </ThemeProvider>  
        </Grid>
        </MuiPickersUtilsProvider>

        </Grid>
         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
           <Chart data={report.data} />
         </Paper>
         </Grid>
         </Grid>
         <br/>
         <Grid container>
         <Grid item xs={12}>
         <Paper className={fixedHeightPaper}>
         <Grid container justifyContent="flex-end">
            <CSVLink className={classes.link} 
              filename={exportCSV.filename}
              headers={exportCSV.header}
              data={exportCSV.data}>
              <Button variant="outlined">Export CSV</Button>
            </CSVLink>
         </Grid>
            <Table data={report.data.Data} />
         </Paper>
         </Grid>
         </Grid>
         <Box pt={4}>
         </Box>
         </Container>

        )
    } else {
      return (<h3> loading </h3>)
    }
  }

export default HarvestReport
